//*Importing necessary modules
import React from "react";

//*Importing hooks from react-router-dom and react-redux
import { useSelector } from "react-redux";
import { Navigate, useLocation, Outlet } from "react-router-dom";

//*Importing helper functions
import { hasAccessToPath } from "../../utils/permissions/permissions";

//*Importing common components
import { Loading } from "../common/Loading";

// ProtectedRoute component to guard routes based on user permissions
const ProtectedRoute: React.FC = () => {
	// Get the current user from the Redux store
	const { me } = useSelector((store: any) => store.auth);
	const location = useLocation();

	// If user data is not available, show a loading indicator
	if (!me) {
		return <Loading />;
	}

	const path = location.pathname;
	const permissions = Array.isArray(me?.permissions) ? me.permissions : undefined;
	const roleSlug = me?.role?.slug;

	if ((roleSlug === "ADMIN" || roleSlug === "SUPER") && Array.isArray(permissions) && permissions.length === 0) {
		return <Outlet />;
	}

	// Check if the user has access to the current path
	const hasAccess = hasAccessToPath(path, permissions);

	// If the user has access, render the child components
	if (hasAccess) {
		return <Outlet />;
	} else {
		// If the user does not have access, navigate to the unauthorized page
		return <Navigate to="/unauthorized" state={{ from: location }} replace />;
	}
};

export default ProtectedRoute;
